import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div>
      <App/>
    </div>
  </React.StrictMode>
);


// setInterval(tick, 5000);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// import React from 'react'
// import ReactDOM from 'react-dom/client';
// const root=ReactDOM.createRoot(document.getElementById("root"));
// function tick(){
//   const element=(
//     <div>
//       <h1>
//         Hemlo Worlmd
//       </h1>
//       <h2>
//         It is {new Date().toLocaleTimeString()}.
//       </h2>
//     </div>
//   );
//   root.render(
//       element
//   );
// }

// setInterval(tick, 10000);
